import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import 'jstree';

ko.jstree = {};

function createJsTree(element, data) {
    if ($(element).jstree) {
        $(element).jstree('destroy');
    }

    $(element)
        .jstree({
            'core': {
                'data': data,
                expand_selected_onload: true,
                'themes': {
                    'name': 'proton',
                    'responsive': true
                },

                //  cf: github.com/vakata/jstree/issues/835
                worker: false
            },
            "checkbox": {
                "keep_selected_style": false
            },
            "search": {
                "show_only_matches": true,
                "show_only_matches_children": true
            },
            "plugins": ["checkbox", "search"]
        });
}

function registerHandlers(element, selectedLeavesObs, selectedLeavesData) {
    ko.utils.registerEventHandler(element, "loaded.jstree", function (e) {

        if (ko.jstree[element.id].handlerEnabled === false) {
            return;
        }

        if (_.isEmpty(selectedLeavesData)) {
            return;
        }

        var instance = $(element).jstree(true);

        ko.jstree[element.id].handlerEnabled = false;

        setTreeCheckboxesBasedOnSelectedLeaves(instance, selectedLeavesData);

        ko.jstree[element.id].handlerEnabled = true;

    });

    ko.utils.registerEventHandler(element, "select_node.jstree", function (e) {

        if (ko.jstree[element.id].handlerEnabled === false) {
            return;
        }

        var instance = $(element).jstree(true);

        ko.jstree[element.id].handlerEnabled = false;

        setSelectedLeavesObsBasedOnCheckboxes(instance, selectedLeavesObs);

        ko.jstree[element.id].handlerEnabled = true;

    });

    ko.utils.registerEventHandler(element, "deselect_node.jstree", function (e) {

        if (ko.jstree[element.id].handlerEnabled === false) {
            return;
        }

        var instance = $(element).jstree(true);

        ko.jstree[element.id].handlerEnabled = false;

        setSelectedLeavesObsBasedOnCheckboxes(instance, selectedLeavesObs);

        ko.jstree[element.id].handlerEnabled = true;
    });
}

function setTreeCheckboxesBasedOnSelectedLeaves(jstreeinstance, selectedLeavesData) {
    var jstreeData = jstreeinstance._model.data;

    jstreeinstance.deselect_all(true); //true means suppress event

    for (var jstreeDataItem in jstreeData) {

        if (jstreeData.hasOwnProperty(jstreeDataItem) && (jstreeDataItem !== '#')) {
            //set leaves only
            if ((jstreeData[jstreeDataItem].parent !== "#") && ($.inArray(jstreeData[jstreeDataItem].text, selectedLeavesData) >= 0))
            {
                jstreeinstance.select_node(jstreeDataItem, true); //true means suppress events
            }
        }
    }
}

function setSelectedLeavesObsBasedOnCheckboxes(jstreeinstance, selectedLeavesObs) {
    //the value 'true' in get_top_selected, get_bottom_selected etc means return full object not just ids

    if (selectedLeavesObs && ko.isObservable(selectedLeavesObs)) {
        var allSelectedLeaves = jstreeinstance.get_bottom_selected(true);
        //jstree apis may not perform as documented (e.g. get_top_selected), so being safe to select leaves only
        // # is the top most level parent
        var leavesWithNoParentSelected = allSelectedLeaves.filter(function (leaf) { return leaf.parent !== "#"; });

        selectedLeavesObs($.map(leavesWithNoParentSelected, function (selectedItem) { return selectedItem.text; }));
    }
}

ko.bindingHandlers.jstree = {

    init: function (element, valueAccessor, allBindingsAccessor, deprecated, bindingContext) {

        if (!element.id) {
            var id = new Date().getTime() + '' + Math.floor((1 + Math.random()) * 100);
            element.id = id;
        }

        ko.jstree[element.id] = {};

        ko.jstree[element.id].handlerEnabled = true;

        ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
            // This will be called when the element is removed by Knockout or
            // if some other part of your code calls ko.removeNode(element)
            $(element).jstree(true).destroy();
        });
    },

    update: function (element, valueAccessor, allBindingsAccessor, deprecated, bindingContext) {
        //NOTE: the following line is required for update to fire
        ko.unwrap(valueAccessor());

        let tree = ko.jstree[element.id]

        if (tree.handlerEnabled === false) {
            return;
        }

        var selectedLeavesObs = valueAccessor() || {};

        var treeData = ko.unwrap(allBindingsAccessor.get('data'));

        var searchString = allBindingsAccessor.get('searchString');

        var selectedLeavesData = ko.isObservable(selectedLeavesObs) ? ko.unwrap(selectedLeavesObs.peek()) : [];

        tree.handlerEnabled = false;

        createJsTree(element, treeData);

        registerHandlers(element, selectedLeavesObs, selectedLeavesData);

        var instance = $(element).jstree(true);

        setTreeCheckboxesBasedOnSelectedLeaves(instance, selectedLeavesData);

        tree.handlerEnabled = true;

        searchString.subscribe(function (value) {
            if (instance.element) {
                instance.search(value);
            }
        });
    }
};
